import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { localeShortDateTime } from "../../../../app/datetimeUtils";
import { scoreReportEssayLink } from "../../../../app/links";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { PromptUsage } from "./promptReportApiSlice";

export function CrPromptScoreTable(props: { className: string; scores: PromptUsage[] }) {
	const dateTimeTemplate = (rowData: PromptUsage) => {
		return (
			<Link className="link" to={scoreReportEssayLink(rowData.essayId)}>
				{localeShortDateTime(rowData.lastUsedDate)}
			</Link>
		);
	};

	return (
		<DataTable
			value={props.scores}
			dataKey="essayId"
			loading={props.scores == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}>
			<Column
				header="Most Recent Submission"
				body={dateTimeTemplate}
				sortable
				sortField="date"></Column>
			<Column header="Prompt" field="promptName" sortable></Column>
			<Column header="Drafts" field="draftCount" sortable></Column>
			<Column header="Holistic/Total Score" field="totalScore" sortable></Column>
		</DataTable>
	);
}
